module.exports = __webpack_public_path__ + "static/media/welcomeDemo3.e90de32e.png";